import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing development configuration and profile

/**
 * Class representing the table view for balance adjustments.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            height: screen.width < 820 ? 400 : 0, // Set height based on screen width
                            columns: [
                                // Define columns for the DataTable
                                {
                                    id: 'Id',
                                    header: _('ID'), // Header label
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserId',
                                    header: _('ID Usuario'), // Header label for User ID
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'UserName',
                                    header: _('Nombre Usuario'), // Header label for User Name
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'CreatedLocalDate',
                                    header: _('Fecha de Creación'), // Header label for Creation Date
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    sort: 'text',
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'Amount',
                                    header: _('Monto'), // Header label for Amount
                                    width: 100,
                                    sort: 'int',
                                    format: webix.Number.numToStr({
                                        // Number formatting
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                },
                                {
                                    id: 'Description',
                                    header: _('Descripción'), // Header label for Description
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'TypeBalance',
                                    header: _('Tipo saldo'), // Header label for Balance Type
                                    options: [
                                        // Options for balance type
                                        { id: '0', value: _('Saldo recargas') },
                                        { id: '1', value: _('Saldo retiros') },
                                    ],
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'UserCreated',
                                    header: _('Usuario Creo'), // Header label for Created By User
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'BeforeAdjust',
                                    header: _('Saldo Antes de Ajuste'), // Header label for Balance Before Adjustment
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'AfterAdjust',
                                    header: _('Saldo Despues de Ajuste'), // Header label for Balance After Adjustment
                                    width: 250,
                                    sort: 'int',
                                },
                            ],
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // ID for the pager
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        grid = $$('datatable'); // Reference to the DataTable
        const _ = this.app.getService('locale')._; // Localization service
        var url =
            devConfig.geturlApi() + // Base URL for API requests
            'es/BalanceAdjustments/GetBalanceAdjustments?Partner=' +
            id_partner +
            '&'; // URL for fetching balance adjustments
        var filter = ''; // Initialize filter string

        // Event listener for filtering balance adjustments
        this.on(this.app, 'balanceAdjustments:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string

            // Iterate through filter data entries
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add date to filter
                                string1 = string1 + '&dateTo=' + date; // Add date to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to filter
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                devConfig.geturlApi() +
                    'es/BalanceAdjustments/GetBalanceAdjustments?Partner=' +
                    id_partner +
                    '&' +
                    '?start=0&count=' +
                    grid.data.$pagesize +
                    '&PlayerId=' +
                    Id, // Load data for selected player
            );
        });

        // Popup configuration for adding adjustments
        var popupAdd = webix.ui({
            view: 'window', // Window view
            id: 'AddAdjustments', // ID for the popup
            height: 450, // Height of the popup
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    {
                        view: 'label',
                        label: _('Ajustar Saldo'), // Label for the popup
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position of the popup
            modal: true, // Modal popup
            body: {
                view: 'form', // Form view for input
                id: 'addform', // ID for the form
                elements: [
                    {
                        view: 'text',
                        label: _('Usuario Id:'), // Label for User ID input
                        name: 'UserId', // Name for the input
                        labelWidth: 150,
                        labelPosition: 'top',
                        type: 'number', // Input type
                        required: true, // Required field
                    },
                    {
                        view: 'combo',
                        label: _('Tipo Saldo:'), // Label for Balance Type input
                        name: 'TypeBalance', // Name for the input
                        required: true,
                        labelPosition: 'top',
                        options: [
                            // Options for balance type
                            { id: '0', value: _('Saldo recargas') },
                            { id: '1', value: _('Saldo retiros') },
                        ],
                        labelWidth: 150,
                    },
                    {
                        view: 'text',
                        label: _('Monto:'), // Label for Amount input
                        name: 'Amount', // Name for the input
                        type: 'number',
                        labelWidth: 150,
                        labelPosition: 'top',
                        required: true, // Required field
                    },
                    {
                        view: 'textarea',
                        label: _('Descripción:'), // Label for Description input
                        name: 'Description', // Name for the input
                        labelWidth: 150,
                        labelPosition: 'top',
                        required: true, // Required field
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for AJAX request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'BalanceAdjustments/Adjustment', // API endpoint for saving adjustments
                                                '{"UserId":"' +
                                                    values.UserId +
                                                    '", "TypeBalance":"' +
                                                    values.TypeBalance +
                                                    '", "Amount":"' +
                                                    values.Amount +
                                                    '", "Description":"' +
                                                    values.Description +
                                                    '", "Partner":"' +
                                                    id_partner +
                                                    '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response JSON
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Error!', // Error title
                                                                ),
                                                                type: 'alert-error',
                                                                text: json.AlertMessage, // Error message
                                                            });
                                                        } else {
                                                            webix.message(
                                                                'Saldo Ajustado', // Success message
                                                            );
                                                            grid.clearAll(); // Clear grid data
                                                            grid.load(
                                                                url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide the popup
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'), // Error title
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Error message for validation
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate form on change
                        },
                    },
                },
            },
        });

        // Event listener for showing the add adjustment popup
        this.on(this.app, 'addAdjustment:button', (filter) => {
            popupAdd.show(); // Show the popup
        });
    }
}

// FILE DOCUMENTED
